import { ReactNode } from 'react'

import { Box, Grid } from '@mui/material'

export function Template({ children }: { children: ReactNode }) {
  return (
    <>
      <Box
        display="flex"
        alignItems="center"
        flexDirection="column"
        justifyContent="flex-start"
        width="100%"
        height="100vh"
        bgcolor="#f6f8fd"
      >
        <Grid
          width="100%"
          gridAutoRows="auto"
          container
          gridTemplateColumns={{
            xs: '1fr',
            md: '1fr'
          }}
          gridTemplateAreas={{
            xs: 'content',
            md: 'content'
          }}
          mb="xxs"
        >
          <Grid item width="100%">
            <Box width="100%" display="flex">
              <>{children}</>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  )
}

export default Template
